import { render, staticRenderFns } from "./fvMenu.vue?vue&type=template&id=5ed54dcc&lang=pug&"
import script from "./fvMenu.vue?vue&type=script&lang=js&"
export * from "./fvMenu.vue?vue&type=script&lang=js&"
import style0 from "./fvMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvMenu.vue
// module id = 123
// module chunks = 0 1